import ApiService from '@/services/core/api.service'

const HistoryService = {
  async get (query = '') {
    return ApiService.get(`disbursement-associate/reports/check-signing?${query}`)
  },

  async post (payload) {
    return ApiService.post('disbursement-associate/reports/check-signing', payload)
  },

  async put (payload) {
    return ApiService.put(`disbursement-associate/reports/check-signing/${payload.id}`, payload)
  },

  async delete (payload) {
    return ApiService.delete(`disbursement-associate/reports/check-signing/${payload.id}`)
  }
}

export default HistoryService
